import { render, staticRenderFns } from "./HostingVServerInfo.vue?vue&type=template&id=2709099f&"
import script from "./HostingVServerInfo.vue?vue&type=script&lang=js&"
export * from "./HostingVServerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2709099f')) {
      api.createRecord('2709099f', component.options)
    } else {
      api.reload('2709099f', component.options)
    }
    module.hot.accept("./HostingVServerInfo.vue?vue&type=template&id=2709099f&", function () {
      api.rerender('2709099f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/vps/HostingVServerInfo.vue"
export default component.exports